export const CHANGE_WORKSHOP = 'scenes/VehicleDetail/Sinister/Workwhop/change_workshop'
export const CHANGE_EDITTING = 'scenes/VehicleDetail/Sinister/Workwhop/change_editting'
export const NEW_WORKSHOP = 'scenes/VehicleDetail/Sinister/Workwhop/new_workshop'



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/ClaimData/Workshop/constants.js